// extracted by mini-css-extract-plugin
export var avatarContainer = "_ab-0";
export var avatarTypingWave = "_ab-i";
export var gray = "_ab-f";
export var green = "_ab-c";
export var icon = "_ab-9";
export var image = "_ab-1";
export var lg = "_ab-6";
export var md = "_ab-5";
export var presenceDot = "_ab-b";
export var red = "_ab-d";
export var sm = "_ab-4";
export var status = "_ab-a";
export var typingDot = "_ab-h";
export var typingPill = "_ab-g";
export var xl = "_ab-7";
export var xs = "_ab-3";
export var xxl = "_ab-8";
export var xxs = "_ab-2";
export var yellow = "_ab-e";